import React, { useEffect, useState } from 'react';
import { Box, ButtonBase, Dialog, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import Text from '../../../../../components/Text';
import { CloseIcon } from '../../../../../components/Icon';
import { Checkbox } from '../../../../DutyAssign/components/Attendance/Setting';
import StyleButton from '../../../../../components/StyleButton';
import { eadmissionAPI } from '../../../../../apis';
import { useGetLoginInfo } from '../../../../../utils/hooks';

const useStyles = makeStyles(() => ({
  dialog: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: 'none',
    },
    '& .MuiPaper-root': {
      backgroundColor: '#FFFFFF',
      borderRadius: '0.9375rem',
      boxShadow: '0 -0.125rem 1.3125rem rgba(30, 56, 140, 0.18)',
      margin: '0',
      width: '50rem',
      paddingTop: '2.25rem',
      maxHeight: '50rem',
    },
  },
  closeIcon: {
    fontSize: '1.375rem',
    color: '#538fff',
  },
}));

const NotificationPopup = ({
  eaId,
  caseNo,
  ipasHospCode,
  specialtyCode,
  subSpecialtyCode,
  isolationRoomCode,
  handleClose,
}) => {
  const classes = useStyles();
  const [list, setList] = useState([]);
  const loginInfo = useGetLoginInfo();
  console.log('list', list);

  const getTicketWard = async () => {
    try {
      const params = {
        caseNo,
        ipasHospCode,
        specialtyCode,
        subSpecialtyCode,
        isolationRoomCode,
      };
      const { result } = await eadmissionAPI.getTicketWard(params);
      setList(
        _.filter(
          _.map(result, (item, key) => ({
            ...item[0],
            key,
            selected: item?.[0]?.WARD_ID !== loginInfo.wardId ? true : false,
          })),
          (item) => item.WARD_ID
        )
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTicketWard();
  }, []);

  const handleSelect = (key) => () => {
    setList((preList) =>
      _.map(preList, (item) => ({
        ...item,
        selected: item.key === key ? !item.selected : item.selected,
      }))
    );
  };

  const handleSend = async () => {
    try {
      const params = {
        eaId,
        pushInfos: _.map(
          _.filter(list, (item) => item.selected),
          (item) => ({
            type: item.key,
            wardId: item.WARD_ID,
          })
        ),
      };
      await eadmissionAPI.sendAdmission(params);
      handleClose();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Dialog open={true} className={classes.dialog}>
      <Box p="0 1.9rem">
        <Box display="flex" justifyContent="space-between">
          <Text fontSize="1.5rem" color="#2E4469" fontFamily="NotoSans-Bold">
            Your change is saved.
          </Text>
          <ButtonBase onClick={handleClose}>
            <CloseIcon className={classes.closeIcon} />
          </ButtonBase>
        </Box>
        <Box mt="1.25rem" mb="1.62rem">
          <Text fontSize="1rem" color="#2E4469">
            As &quot;Remark&quot; or &quot;Special Alert&quot; or &quot;Specialty Remark&quot; is modified, do you want
            to send notification to :
          </Text>
        </Box>
        <Box display="flex" flexDirection="column" gridGap="1.25rem">
          {list.map((item) => (
            <Box display="flex" alignItems="center" gridGap="0.75rem" key={item.key}>
              <Checkbox check={item.selected} handleChange={handleSelect(item.key)} />
              <Text fontSize="1rem" color="#2E4469">
                {`${item.HOSPITAL_CODE} ${item.WARD_NAME}${ENUM[item.key]}`}
              </Text>
            </Box>
          ))}
        </Box>
      </Box>
      <Box
        mt="2.5rem"
        display="flex"
        justifyContent="center"
        alignItems="center"
        p="1rem"
        boxShadow="0px -1px 0px 0px #E4E7EB"
        gridGap="1.25rem"
      >
        <StyleButton onClick={handleClose} width="12.5rem" height="2.875rem" text="Cancel" />
        <StyleButton
          onClick={handleSend}
          width="12.5rem"
          height="2.875rem"
          text="Send"
          type="fill"
          disabled={!_.some(list, (item) => item.selected)}
        />
      </Box>
    </Dialog>
  );
};

const ENUM = {
  aed: '',
  adm: '(Admission Officer)',
  bedCo: '(Bed Coordinator)',
  ward: '(Calling / Assigned Ward)',
};

export default NotificationPopup;
